import { GarageAlertIcon } from './GarageAlertIcon';

/**
 * author: Michael Richins
 * id 03ED4E2F-41CE-47D7-ABB4-C8515C202499
 * name garage-alert
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/garage-alert.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 */
export const GarageWarningIcon = GarageAlertIcon;
export default GarageWarningIcon